var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/utils/thermostatSelectorList.js
var require_thermostatSelectorList = __commonJS({
  "server/utils/thermostatSelectorList.js"(exports, module) {
    function parseSelectorList(value) {
      if (value === null || value === void 0) {
        return [];
      }
      let list = [value];
      if (Array.isArray(value)) {
        list = value;
      } else if (typeof value === "string" && value.trim().startsWith("[")) {
        try {
          list = JSON.parse(value);
        } catch (e) {
          list = [value];
        }
      }
      const selectors = [];
      list.forEach((selector) => {
        if (typeof selector !== "string") {
          return;
        }
        const trimmed = selector.trim();
        if (trimmed !== "" && !selectors.includes(trimmed)) {
          selectors.push(trimmed);
        }
      });
      return selectors;
    }
    function serializeSelectorList(selectors) {
      const list = parseSelectorList(selectors);
      if (list.length === 0) {
        return "";
      }
      if (list.length === 1) {
        return list[0];
      }
      return JSON.stringify(list);
    }
    module.exports = {
      parseSelectorList,
      serializeSelectorList
    };
  }
});
const __cjsModule = require_thermostatSelectorList();
export default __cjsModule;
export const parseSelectorList = __cjsModule.parseSelectorList;
export const serializeSelectorList = __cjsModule.serializeSelectorList;
